import MissionApp from './MissionApp';
import MissionsApp from './MissionsApp';
import {authRoles} from "../../../../store/actionreducers/auth/auth";

export const MissionsAppConfig = {
    auth: [...authRoles.cc, ...authRoles.admin], //  [cc, admin]
    routes: [
        {
            path: '/apps/mission/:id',
            component: MissionApp
        },
        {
            path: '/apps/mission',
            component: MissionsApp
        }
    ]
};



// WEBPACK FOOTER //
// ./src/main/content/callHelper/mission/MissionsAppConfig.js